var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('v-select',{attrs:{"label":_vm.$t('menu.manageClient'),"items":_vm.clientItems,"value":_vm.selectedClient},on:{"change":_vm.onClientChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }